import React, { useMemo, useCallback, useState, useRef } from 'react';

import {
  DialogTitle,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';

import { t } from '~/helpers';

export default function ConfirmDialog(props) {
  const { onClose, handleSubmit, open } = props;
  const [error, setError] = useState(false);
  const confirmarRef = useRef('');

  const handleConfirmar = useCallback(async () => {
    try {
      props.handleSubmit();
      onClose();
    } catch (err) {}
  }, []);

  const handleClose = () => {
    setError(false);
    onClose();
    confirmarRef.current = '';
  };

  return (
    <Dialog
      fullWidth
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xs"
      open={open}
    >
      <DialogTitle id="alert-dialog-title">
        {t('s.geral.botaoconfirmar')}
      </DialogTitle>
      <DialogContent>
        {t('s.operacao.precoproduto.confirmaalteracao').replace(
          '%s',
          `${props.selectedValue}`
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleConfirmar} color="primary">
          {t('s.geral.botaoconfirmar')}
        </Button>
        <Button onClick={handleClose} color="secondary">
          {t('s.geral.botaocancelar')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmDialog.propTypes = {};
ConfirmDialog.defaultProps = {};
